import React from "react";
import insta from "./img/instagram.svg";
import face from "./img/facebook.svg";
export class SocialMenu extends React.Component {
  render() {
    return (
      <ul className="social-menu">
        <li>
          <a
            href="//facebook.com/moizstudio/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={face} alt="facebook" />
          </a>
        </li>
        <li>
          <a
            href="//instagram.com/moizstudio/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={insta} alt="instagram" />
          </a>
        </li>
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/SocialMenu.js